
import { SleepRecordsTable } from "@/components/dashboard/SleepRecordsTable"
import { NapRecordsTable } from "@/components/dashboard/NapRecordsTable"
import { FeedingRecordsTable } from "@/components/dashboard/FeedingRecordsTable"
import { useMediaQuery } from "@/hooks/use-media-query"
import { motion } from "framer-motion"

interface ActivityTablesProps {
  childId: string
  timezone: string
}

export function ActivityTables({ childId, timezone }: ActivityTablesProps) {
  const isMobile = useMediaQuery("(max-width: 480px)")
  const isTablet = useMediaQuery("(max-width: 768px)")
  
  // Animation variants for staggered loading of tables
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { 
      opacity: 1,
      transition: { 
        staggerChildren: 0.15,
        delayChildren: 0.2
      }
    }
  };
  
  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 }
  };
  
  const tablePadding = isMobile ? "p-2" : isTablet ? "p-3" : "p-3 sm:p-6";

  return (
    <motion.div 
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      className="space-y-3 md:space-y-4 w-full"
    >
      <motion.div 
        variants={itemVariants}
        className={`dark:bg-gradient-to-br dark:from-gray-800/50 dark:to-gray-900/50 light:bg-white ${tablePadding} rounded-xl sm:rounded-2xl shadow-xl backdrop-blur-lg dark:border-white/5 light:border-slate-200 w-full`}
      >
        <div className="overflow-x-auto pb-1 -mx-1 px-1">
          <SleepRecordsTable 
            childId={childId} 
            limit={isMobile ? 3 : 5} 
            timezone={timezone} 
          />
        </div>
      </motion.div>
      
      <motion.div 
        variants={itemVariants}
        className={`dark:bg-gradient-to-br dark:from-gray-800/50 dark:to-gray-900/50 light:bg-white ${tablePadding} rounded-xl sm:rounded-2xl shadow-xl backdrop-blur-lg dark:border-white/5 light:border-slate-200 w-full`}
      >
        <div className="overflow-x-auto pb-1 -mx-1 px-1">
          <NapRecordsTable 
            childId={childId} 
            limit={isMobile ? 3 : 5} 
            timezone={timezone} 
          />
        </div>
      </motion.div>
      
      <motion.div 
        variants={itemVariants}
        className={`dark:bg-gradient-to-br dark:from-gray-800/50 dark:to-gray-900/50 light:bg-white ${tablePadding} rounded-xl sm:rounded-2xl shadow-xl backdrop-blur-lg dark:border-white/5 light:border-slate-200 w-full`}
      >
        <div className="overflow-x-auto pb-1 -mx-1 px-1">
          <FeedingRecordsTable 
            childId={childId} 
            limit={isMobile ? 3 : 5} 
            timezone={timezone} 
          />
        </div>
      </motion.div>
    </motion.div>
  )
}
